import Keycloak from "keycloak-js"

/**
 * Keycloak configuration for Smartville SSO
 *
 * Configuration details:
 * - URL: Keycloak server base URL
 * - Realm: The Keycloak realm name
 * - ClientId: The client ID registered in Keycloak
 */
export const keycloakConfig = {
  url: import.meta.env.VITE_KEYCLOAK_URL || "https://sso.smartville.gr/",
  realm: import.meta.env.VITE_KEYCLOAK_REALM || "smartville",
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || "remote-tracker",
}

/**
 * Singleton Keycloak instance
 * This instance persists across React's StrictMode remounts
 */
let keycloakInstance: Keycloak | null = null

/**
 * Get or create Keycloak instance
 * Ensures only one instance exists even with React StrictMode
 */
export function getKeycloakInstance(): Keycloak {
  if (!keycloakInstance) {
    keycloakInstance = new Keycloak(keycloakConfig)
  }
  return keycloakInstance
}

